import React from 'react';
import { useNavigate } from 'react-router-dom';

import { Box, Button, Typography } from '@mui/material';

import { IErrorPageProps } from 'src/components/common/types/errorPageTypes';

const ErrorPage: React.FC<IErrorPageProps> = ({
	title,
	message,
	showGoBackButton = true,
	goBackButtonText = 'GO TO DASHBOARD',
	goBackRoute = '/dashboard',
}) => {
	const navigate = useNavigate();

	const handleGoBack = () => {
		navigate(goBackRoute);
	};

	return (
		<Box
			sx={{
				display: 'flex',
				flexDirection: 'column',
				height: '85vh',
				width: '100vw',
				justifyContent: 'center',
				alignItems: 'center',
				gap: 1,
			}}
		>
			<img
				src='/dave.png'
				height='300px'
				width='520px'
				alt='an animated octopus weeping'
			/>
			<Typography variant='h5'>Well, this is awkward.</Typography>
			<br />
			<br />
			<Typography variant='h5' fontWeight='400'>
				{title}
			</Typography>
			<Typography variant='h5' color='GrayText'>
				{message}
			</Typography>
			{showGoBackButton && (
				<Button
					sx={{ marginTop: 1 }}
					variant='contained'
					onClick={handleGoBack}
				>
					{goBackButtonText}
				</Button>
			)}
		</Box>
	);
};

export default ErrorPage;
